import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const stats = [
    { value: '150+', label: 'Projects Completed', icon: 'ri-rocket-2-line' },
    { value: '98%', label: 'Client Satisfaction', icon: 'ri-heart-line' },
    { value: '24/7', label: 'Support Available', icon: 'ri-customer-service-2-line' },
  ];

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://res.cloudinary.com/dodsf90se/image/upload/v1774525934/top1_mjxpbz.jpg"
          alt="BientoMart Digital Agency"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-darkBlue-700/90 via-darkBlue-600/80 to-darkBlue-500/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 lg:px-8 pt-24 pb-20">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 bg-clairBlue-300/20 border border-clairBlue-300/30 rounded-full px-4 py-1.5 mb-6">
            <div className="w-2 h-2 bg-clairBlue-300 rounded-full"></div>
            <span className="text-clairBlue-200 text-xs font-semibold uppercase tracking-widest">Professional Digital Solutions</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-white mb-6">
            <span className="block font-display text-4xl lg:text-6xl font-bold leading-tight">
              Grow Your Business Online &
            </span>
            <span className="block font-display text-4xl lg:text-6xl font-bold italic text-clairBlue-300 leading-tight">
              Start Making Money 
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-gray-300 text-lg lg:text-xl leading-relaxed mb-8 max-w-2xl">
            Professional digital services to grow your business + cutting-edge AI tools to work smarter and make money with us.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-14">
            <button
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="flex items-center justify-center gap-2 bg-clairBlue-300 hover:bg-clairBlue-200 text-darkBlue-500 font-bold text-base px-8 py-4 rounded-xl transition-all hover:scale-105 whitespace-nowrap"
            >
              Get Website
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => navigate('/ai-money')}
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold text-base px-8 py-4 rounded-xl backdrop-blur-sm transition-all hover:scale-105 whitespace-nowrap"
            >
              Make Money with US
              <i className="ri-external-link-line"></i>
            </button>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-8">
            {stats.map((stat, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-clairBlue-300/20 rounded-xl border border-clairBlue-300/30">
                  <i className={`${stat.icon} text-clairBlue-300`}></i>
                </div>
                <div>
                  <div className="text-white font-bold text-xl font-display">{stat.value}</div>
                  <div className="text-gray-400 text-xs">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Floating Cards */}
        <div className="hidden lg:block absolute right-8 top-1/2 -translate-y-1/2 space-y-4">
          {[
            { icon: 'ri-global-line', label: 'Website Design', value: '30+ Sites Built', color: 'from-clairBlue-300 to-clairBlue-400' },
            { icon: 'ri-bar-chart-2-line', label: 'Social Media', value: '400% Avg Growth', color: 'from-darkBlue-400 to-darkBlue-500' },
            { icon: 'ri-robot-line', label: 'AI Tools', value: '3 Top-Rated Tools', color: 'from-clairBlue-200 to-clairBlue-300' },
          ].map((card, i) => (
            <div
              key={i}
              className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-5 py-4 flex items-center gap-4 min-w-52"
              style={{ animation: `float ${2.5 + i * 0.5}s ease-in-out infinite alternate` }}
            >
              <div className={`w-10 h-10 flex items-center justify-center bg-gradient-to-br ${card.color} rounded-xl`}>
                <i className={`${card.icon} text-white`}></i>
              </div>
              <div>
                <div className="text-white text-xs font-semibold">{card.label}</div>
                <div className="text-clairBlue-200 text-xs">{card.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2" style={{ animation: 'bounce 2s infinite' }}>
        <button onClick={scrollToContact} className="flex flex-col items-center gap-1 text-white/50 hover:text-white/80 transition-colors cursor-pointer">
          <span className="text-xs">Scroll</span>
          <i className="ri-arrow-down-line text-lg"></i>
        </button>
      </div>

      <style>{`
        @keyframes float {
          from { transform: translateY(0px); }
          to { transform: translateY(-10px); }
        }
      `}</style>
    </section>
  );
}
